import React from "react";

/**
 * The title block every page opens with.
 *
 * Pages had drifted apart here — some rendered an icon, some did not, and the
 * "N total" line and primary button were placed differently on each. One
 * component keeps them aligned, and gives the count and action a fixed home.
 *
 * @param {React.ReactNode} icon     Optional lucide icon, rendered in brand colour
 * @param {string}          title
 * @param {React.ReactNode} subtitle One line on what the page is for
 * @param {React.ReactNode} meta     Secondary line, e.g. "12 clients"
 * @param {React.ReactNode} actions  Primary action(s), right-aligned
 */
const PageHeader = ({ icon, title, subtitle, meta, actions }) => (
  <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
    <div className="min-w-0">
      <h1
        className="text-2xl sm:text-3xl font-semibold flex items-center gap-2"
        style={{ color: "var(--brand)" }}
      >
        {icon}
        {title}
      </h1>

      {subtitle && (
        <p className="mt-1 text-sm" style={{ color: "var(--main-text-muted)" }}>
          {subtitle}
        </p>
      )}

      {meta && (
        <p
          className="mt-2 text-sm font-medium"
          style={{ color: "var(--main-text-muted)" }}
        >
          {meta}
        </p>
      )}
    </div>

    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </div>
);

export default PageHeader;
